import { useMutation } from '@tanstack/react-query';
import { createBrand, ICreateBrandResponse } from 'src/api/createBrand';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { useUserTracking } from '../useUserTracking/useUserTracking';

export const useCreateBrand = (onMutationSuccess: () => void) => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();

  return useMutation(
    (params: { name: string; file?: File }) => createBrand(params.name, params.file),
    {
      onSuccess: (data: ICreateBrandResponse) => {
        showSnackbar({
          status: SnackbarStatus.SUCCESS,
          message: `${data.name} has successfully been created.`,
        });
        onMutationSuccess();
      },
      onError: (error, req) => {
        showSnackbar({
          message: `Unable to create ${req.name}`,
          status: SnackbarStatus.ERROR,
        });

        captureException(error);
      },
    },
  );
};
